import React from "react";
import { Modal } from "react-bootstrap";
import { default as ImageGallery } from "../lib/image-gallery.js";
import Panzoom from "../lib/jquery.panzoom.js";
import classNames from 'classnames';

class ImageGalleryModal extends React.Component {
    state = {
        showImageGallery: false,
        imageIndex: 0
    };

    resizeImage = () => {
        var self = this;
        var viewWidth = (Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
        var viewHeight = (Math.max(document.documentElement.clientHeight, window.innerHeight || 0)) - 100;
        var container = $(".fullscreen .image-gallery-slide.center .image-gallery-image-inner");
        var image = container.find("img");
        if (image && image.length > 0) {
            var theImage = new Image();
            theImage.src = image.attr("src");

            var imageWidth = theImage.width;
            var imageHeight = theImage.height;
            var imageRatio = imageWidth / imageHeight;
            var screenRation = viewWidth / viewHeight;

            if (screenRation > imageRatio) {
                image.height(viewHeight - 5);
                image.width('auto');
            }
            else {
                image.width(viewWidth - 5);
                image.height('auto');
            }

            if (container.length == 1) {
                self.setupPanzoom(container[0]);
            }
        }

    };

    setupPanzoom = (element) => {
        if (element) {
            $(".image-gallery-image-inner").each(function() {
                $(this).panzoom('destroy');
                
                $(this).css({
                    transform: '',
                    transition: '' 
                });
            });
            var zoomElement =
                Panzoom(element,
                    {
                        minScale: 1, maxScale: 4, increment: .4, exponential: false, panOnlyWhenZoomed: true,
                        $zoomIn: $(".zoomIn"), $zoomOut: $(".zoomOut")
                    }
                );
            zoomElement.$elem.on('mousewheel.focal', function (e) {
                e.preventDefault();
                var delta = e.delta || e.originalEvent.wheelDelta;
                var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
                var test = zoomElement.$elem;
                test.panzoom('zoom', zoomOut, {
                    animate: true,
                    increment: .2,
                    exponential: false,
                    focal: e
                });
            });
        }
    };

    componentDidMount() {
        var self = this;
        this.resizeImage();
        $(window).resize(function () {
            self.resizeImage();
        });
    }

    handleImageLoad = (event) => {
        this.resizeImage();
    };

    onSlide = (index) => {
        this.resizeImage();
        this.props.setImageIndex(index);
    };

    openImageGallery = () => {
        this.setState({ showImageGallery: true });
        let openModalCallback = this.props.openModalCallback;

        if (openModalCallback) {
            openModalCallback();
        }
    };

    closeImageGallery = () => {
        this.setState({ showImageGallery: false });
        let closeModalCallback = this.props.closeModalCallback;
        if (closeModalCallback) {
            closeModalCallback();
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        let showImageGallery = nextProps.showImageGallery || false;
        this.setState({ showImageGallery: showImageGallery });
    }

    render() {
        const { showImageGallery = false } = this.state;
        const { images = [], startIndex = 0, defaultImage = '', imageViewerClassNames = '' } = this.props;

        return (
            <Modal className={classNames('imageViewer', imageViewerClassNames)} show={showImageGallery} onHide={this.closeImageGallery} backdrop="static">
                <Modal.Body>
                    <a onClick={this.closeImageGallery} className="closeButton btn imageViewerButton glyphicon glyphicon-remove"></a>

                    <div className="fullscreen">
                        <a onClick={this.closeImageGallery} className="closeButton btn imageViewerButton glyphicon glyphicon-remove"></a>
                        <button className="zoomIn btn imageViewerButton glyphicon glyphicon-plus"></button>
                        <button className="zoomOut btn imageViewerButton glyphicon glyphicon-minus"></button>
                        <ImageGallery ref={i => this._imageGallery = i}
                            lazyLoad={true}
                            showFullscreenButton={false}
                            items={images}
                            slideInterval={2000}
                            startIndex={startIndex}
                            onSlide={this.onSlide}
                            onImageLoad={this.handleImageLoad}
                            defaultImage={defaultImage} />
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

module.exports = ImageGalleryModal;
